<rw-modal
  modalId="userActionDialogModal"
  datapendoid="user-action-dialog-modal"
  datatestid="user-action-dialog-modal"
  [title]="userActionDialogConfig?.actionTitle"
  [arialabel]="userActionDialogConfig?.actionTitle"
  [dismissible]="true"
  size="lg"
  #modalRef
>
  <div modal-body>
    <div class="row">
      @if (userActionDialogConfig?.selectedUsers && userActionDialogConfig?.selectedUsers.length > 0) {
        <div>
          <p>{{ userActionDialogConfig?.actionHeader }}</p>
          <ul>
            @for (user of userActionDialogConfig?.selectedUsers; track user) {
              <li>
                <b>{{ user.FullName }}</b> (<i>{{ user.Email }}</i>)
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
  <div modal-footer>
    <app-button id="btnClose" buttonStyle="secondary" label="Close" (clickActionEmitter)="close()"> </app-button>
  </div>
</rw-modal>
